module.exports = __webpack_public_path__ + "img/font-zoom-in.b08ddf47.svg";